import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
// This Module's Components
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ErrorHandlerModule } from '../../../error-handler/error-handler.module';
import { FullAirportListComponent } from '../../../full-airport-list/full-airport-list.component';
import { FullAirportListModule } from '../../../full-airport-list/full-airport-list.module';
import { RecentSearchesModule } from '../../../recent-searches/recent-searches.module';
import { SavedSearchesModule } from '../../../saved-searches/saved-searches.module';
import { AirportLookupModalComponent } from './airport-lookup-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FullAirportListModule,
    TabsModule.forRoot(),
    RecentSearchesModule,
    SavedSearchesModule,
    ErrorHandlerModule,
    FormsModule
  ],
  declarations: [AirportLookupModalComponent],
  exports: [AirportLookupModalComponent]
})
export class AirportLookupModalComponentModule {}
